export class HistorySuggest {
  shouldShow: boolean = false;
  shouldShowSuggestWord: boolean = false;
  wordTitle: string = '';
  suggestWordArray: string[] = [];
  shouldShowCategory: boolean = false;
  categoryTitle: string = '';
  categoryArray: CategorySuggest[] = [];

  constructor(apiReslut: Document) {
    const wordTitle = HistorySuggest.getWordTitle(apiReslut);
    if (wordTitle) {
      this.wordTitle = wordTitle;
      const wordElements = apiReslut.getElementsByTagName('word');
      this.suggestWordArray = Array.prototype.map.call(wordElements, el => el.textContent);
      this.shouldShowSuggestWord = (0 < this.suggestWordArray.length);
    }

    const categoryTitle = HistorySuggest.getCategoryTitle(apiReslut);
    if (categoryTitle) {
      this.categoryTitle = categoryTitle;
      const categoriesElements = apiReslut.getElementsByTagName('categorys');
      this.categoryArray = Array.prototype.map.call(
        categoriesElements,
        element => new CategorySuggest(
          element.getElementsByTagName('cateName')[0]?.textContent,
          element.getElementsByTagName('llCateCd')[0]?.textContent,
          element.getElementsByTagName('lCateCd')[0]?.textContent,
          element.getElementsByTagName('mCateCd')[0]?.textContent
        )
      );
      this.shouldShowCategory = (0 < this.categoryArray.length);
    }

    this.shouldShow = this.shouldShowSuggestWord || this.shouldShowCategory;
  }

  private static getWordTitle(result: Document): string | null {
    const wordTitleElement = result.getElementsByTagName('wordTitle')[0];
    if (wordTitleElement == null) {
      return null;
    }

    switch (wordTitleElement.textContent) {
      case 'searchHistory':
        return '検索履歴';
      case 'recommendWord':
        return 'おすすめワード';
      default:
        return null;
    }
  }

  private static getCategoryTitle(result: Document): string | null {
    const cateTitleElement = result.getElementsByTagName('cateTitle')[0];
    if (cateTitleElement == null) {
      return null;
    }

    switch (cateTitleElement.textContent) {
      case 'browsingCategory':
        return '閲覧したカテゴリー';
      case 'purchasedCategory':
        return '購入済カテゴリー';
      case 'recommendCategory':
        return 'おすすめカテゴリー';
      default:
        return null;
    }
  }
}

export class CategorySuggest {
  categoryName: string;
  llCategryCode: string;
  lCategoryCode: string;
  mCategoryCode: string;

  constructor(categoryName: string, llCategryCode: string, lCategoryCode: string, mCategoryCode: string) {
    this.categoryName = categoryName;
    this.llCategryCode = llCategryCode;
    this.lCategoryCode = lCategoryCode;
    this.mCategoryCode = mCategoryCode;
  }
}
